import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IntermediaryApplicationProps } from 'api/IntermediaryApplicationsApi';

import { EmployeeDisplayProps } from './application';

export enum ContractorPortalActionType {
  SaveContractorApplication = 'contractor-portal/apply',
}

export interface ContractorPortalState {
  contractorApplication: Partial<IntermediaryApplicationProps> | null;
  csm: EmployeeDisplayProps | null;
  created: boolean;
  alreadyExistingEmail?: string;
  isEmailError?: boolean;
}

const initialState: ContractorPortalState = {
  contractorApplication: null,
  csm: null,
  created: false,
};

const contractorPortal = createSlice({
  name: 'contractorPortal',
  initialState,
  reducers: {
    setContractorPortalData: (state, { payload }: PayloadAction<Partial<ContractorPortalState>>) => {
      Object.assign(state, payload);
    },
  },
});

export const { setContractorPortalData } = contractorPortal.actions;

export default contractorPortal.reducer;
